<template>
  <section class="hero">
    <div class="container">
      <div class="contacts">
        <div class="image-box" data-aos="zoom-in" data-aos-duration="1500">
          <img src="../assets/media/myphoto.jpeg" />
        </div>
        <div class="title" data-aos="fade-down" data-aos-duration="1500">
          <p class="name">Izumi Keiki</p>
          <p class="name">Web Developer</p>
        </div>
      </div>
      <div data-aos="fade-right" data-aos-duration="3000">
        <p class="intro">
          私は情熱的な開発者であり、自己研鑽に励んで、高品質のサービスを提供することに強いこだわりを持っています。仕事に熱心かつ慎重で、クライアントの期待を満たすことに大きな誇りを持っています。仕事への献身は、私が提供するサービスに満足していただけるよう常に最善を尽くします。
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  name: "IntroComponentJa",
};
</script>

<style lang="scss" scoped>
.container {
  max-width: 1280px;
  margin: 0 auto;
  display: flex;
  align-items: center;
  justify-content: center;

  .intro {
    padding: 5rem;
    font-size: 2rem;
    font-family: "Noto Serif JP", serif;
  }

  .contacts {
    display: flex;
    flex-direction: column;
    padding: 0 1rem;
    background-color: #2f9e44;

    .image-box {
      margin-top: 1.5rem;
      padding: 1.5rem;
      position: relative;
      overflow: hidden;
      width: 10rem;
      height: 10rem;
      align-self: center;

      img {
        width: 7rem;
        height: 7rem;
        border-radius: 50%;
        object-fit: cover;
      }
    }

    .title {
      padding: 1rem 0 1.5rem;
      align-self: center;
      text-align: center;

      .name {
        font-size: 1.75rem;
        font-weight: 550;
        white-space: nowrap;
        padding-bottom: 0.5rem;

        &:hover {
          transition: all 0.3s;
          transform: translateY(-3px);
          color: #94d8a1;
          text-shadow: 3px 3px 3px rgb(0 0 0 / 0.25);
          cursor: default;
        }
      }
    }
  }
}

@media screen and (max-width: 1000px) {
  .container {
    .intro {
      font-size: 1.5rem;
    }

    .contacts {
      .image-box {
        width: 9rem;
        height: 9rem;
        img {
          width: 6rem;
          height: 6rem;
        }
      }
      .title {
        padding: 0.5rem 0;
        .name {
          font-size: 1.5rem;
        }
      }
    }
  }
}

@media screen and (max-width: 750px) {
  .container {
    flex-direction: column-reverse;
  }

  .contacts {
    background-image: none;
    justify-content: flex-end;

    .contact {
      margin-top: 0;
      padding: 1rem 0 0;
    }
  }
}
</style>
